import axios from "axios";

class ContactService {

    constructor() {
        this.apiBaseUrl = process.env.REACT_APP_CONTACT_URL;
        this.restClient = axios.create({
            baseURL: this.apiBaseUrl
        });
    }
    getContextUserInformation(username) {
        return this.restClient.post('/context/vbuser', {
            "username": username, "password": ''
        })
    }

}

export default new ContactService();